import checkInputs from "utils/checkInputs";
import checkDocument from "utils/checkDocument";
import { numDecimales, numDecimalesDescuento } from "configurations/constant";
import bigDecimal from "js-big-decimal";

const validate = (nameInput, value) => {
  const response = { value: value, error: null, keyWordError: null };
  switch (nameInput) {
    case "descuentoProducto":
      if (checkInputs.countLenth(value) > 14) {
        response.keyWordError = "isLong";
        response.error = "No ingrese más de 14 dígitos.";
      } else if (!checkInputs.isDecimal(value)) {
        response.keyWordError = "isNotNumeric";
        response.error = "Solo puede ingresar números.";
      } else if (
        checkInputs.countDecimals(value.toString()) > numDecimalesDescuento
      ) {
        response.keyWordError = "isLongDecimal";
        response.error =
          "Solo debe ingresar cantidades con 2 decimales como máximo, separados por 1 punto (.) .";
      }

      return response;
    case "precioUnitario":
      if (checkInputs.countDecimals(value.toString()) > numDecimales) {
        response.keyWordError = "isLongDecimal";
        response.error =
          "Solo debe ingresar cantidades con 6 decimales como máximo, separados por 1 punto (.) .";
      }
      return response;
    case "cantidadProducto":
      if (checkInputs.countLenth(value) > 14) {
        response.keyWordError = "isLong";
        response.error = "No ingrese más de 14 dígitos.";
      } else if (!checkInputs.isDecimal(value.toString())) {
        response.keyWordError = "isNotDecimal";
        response.error = "Solo puede ingresar números.";
      } else if (checkInputs.countDecimals(value.toString()) > numDecimales) {
        response.keyWordError = "isLongDecimal";
        response.error =
          "Solo debe ingresar cantidades con 6 decimales como máximo, separados por 1 punto (.) .";
      }
      return response;
    default:
      return response;
  }
};
//codigoPrincipal
export const validationVoucher = {
  onChange: function checkOnChange(nameInput, value) {
    const response = { value: value, error: null, keyWordError: null };
    switch (nameInput) {
      case "codigoPrincipal":
      case "codigoAuxiliar":
        if (checkInputs.countLenth(value) > 25) {
          response.keyWordError = "isLong";
          response.error = "Solo puede ingresar 25 caracteres";
        }
        return response;
      case "descuentoProducto":
        if (checkInputs.countLenth(value) > 14) {
          response.keyWordError = "isLong";
          response.error = "";
        } else if (!checkInputs.isDecimal(value)) {
          response.keyWordError = "isNotDecimal";
          response.error = "Solo puede ingresar números.";
        } else if (!(Number(value.toString().trim()) >= 0)) {
          response.keyWordError = "isNotDecimal";
          response.error =
            "Solo debe ingresar cantidades con 2 decimales como máximo, separados por 1 punto (.) .";
        }

        return response;
      case "precioUnitario":
        if (checkInputs.countDecimals(value.toString()) > numDecimales) {
          response.keyWordError = "isLongDecimal";
          response.error =
            "Solo debe ingresar cantidades con 6 decimales como máximo, separados por 1 punto (.) .";
        }
        return response;
      case "acarreo":
        if (checkInputs.countDecimals(value) > numDecimalesDescuento) {
          response.keyWordError = "isLongDecimal";
          response.error =
            "Solo debe ingresar cantidades con 2 decimales como máximo, separados por 1 punto (.) .";
        }
        return response;
      case "seguro":
        if (checkInputs.countDecimals(value) > numDecimalesDescuento) {
          response.keyWordError = "isLongDecimal";
          response.error =
            "Solo debe ingresar cantidades con 2 decimales como máximo, separados por 1 punto (.) .";
        }
        return response;
      case "cantidadProducto":
        if (checkInputs.countLenth(value) > 14) {
          response.keyWordError = "isLong";
          response.error = "";
        } else if (!checkInputs.isDecimal(value)) {
          response.keyWordError = "isNotDecimal";
          response.error = "Solo puede ingresar números.";
        } else if (!(Number(value.toString().trim()) >= 0)) {
          response.keyWordError = "isNotDecimal";
          response.error =
            "Solo debe ingresar cantidades con 6 decimales como máximo, separados por 1 punto (.) .";
        }
        return response;
      default:
        return response;
    }
  },
  onSubmit: function checkOnSubmit(data) {
    const errors = {};
    if (checkInputs.notNull(data.codigoPrincipal)) {
      let validateLocal = validate("codigoPrincipal", data.codigoPrincipal);
      if (validateLocal.error) {
        errors.codigoPrincipal = validateLocal.error;
      }
    } else {
      errors.codigoPrincipal =
        "Ingresar el código principal del producto, es necesario.";
    }
    if (!checkInputs.notNull(data.descripcion)) {
      errors.descripcion =
        "Ingresar la descripcion del producto, es necesario.";
    }
    if (checkInputs.notNull(data.cantidadProducto)) {
      let validateLocal = validate("cantidadProducto", data.cantidadProducto);
      if (validateLocal.error) {
        errors.cantidadProducto = validateLocal.error;
      }
    } else {
      errors.cantidadProducto =
        "Ingresar la cantidad de producto, es necesario.";
    }
    if (checkInputs.notNull(data.precioUnitario)) {
      let validateLocal = validate("precioUnitario", data.precioUnitario);
      if (validateLocal.error) {
        errors.precioUnitario = validateLocal.error;
      }
    } else {
      errors.precioUnitario = "Ingresar el precio, es necesario.";
    }

    if (data.estadoMedicina) {
      if (!checkInputs.notNull(data.fechaFabricacion)) {
        errors.fechaFabricacion = "Ingrese la fecha de fabricación, el producto es una medicina."
      }

      if (!checkInputs.notNull(data.fechaCaducidad)) {
        errors.fechaCaducidad = "Ingrese la fecha de caducidad, el producto es una medicina."
      }
    }
    if (checkInputs.notNull(data.acarreo)) {
      if (checkInputs.countDecimals(data.acarreo) > numDecimalesDescuento) {
        errors.acarreo = "Solo debe ingresar cantidades con 2 decimales como máximo, separados por 1 punto (.) ."
      }
    }

    if (checkInputs.notNull(data.seguro)) {
      if (checkInputs.countDecimals(data.seguro) > numDecimalesDescuento) {
        errors.seguro = "Solo debe ingresar cantidades con 2 decimales como máximo, separados por 1 punto (.) ."
      }
    }

    return errors;
  },
};

export const calculateDiscount = (prodDetail) => {
  let price = new bigDecimal(prodDetail.precioUnitario);
  let count = new bigDecimal(prodDetail.cantidadProducto);
  let porcent = new bigDecimal(prodDetail.descuentoProducto);
  if (
    prodDetail.isDescuentoPorcentaje === "false" ||
    prodDetail.isDescuentoPorcentaje === false
  ) {
    return Number(porcent.multiply(count).value);
  } else {
    porcent = porcent.divide(new bigDecimal(100));
    return Number(price.multiply(count).multiply(porcent).value);
  }
};

//Valida los campos de datos de exportación
export const validationExportData = {
  onSubmit: function checkOnSubmit(data) {
    const errors = {};

    if (!checkInputs.notNull(data.condicionEntrega)) {
      errors.condicionEntrega =
        "Seleccionar la condición de entrega, es necesario.";
    }

    if (checkInputs.notNull(data.monedaOperacion)) {
      if (data.monedaOperacion === "ZZZ") {
        if (
          data.detalleMoneda === undefined ||
          !checkInputs.notNull(data.detalleMoneda)
        ) {
          errors.detalleMoneda =
            "Ingresar el detalle de la moneda, es necesario.";
        } else {
          if (!checkInputs.isAlphanumeric(data.detalleMoneda)) {
            errors.detalleMoneda = "Ingresar solo caracteres alfanuméricos.";
          }
        }
      }
    }

    if (data.tipoCambio !== undefined || checkInputs.notNull(data.tipoCambio)) {
      if (!checkInputs.isDecimal(data.tipoCambio)) {
        errors.tipoCambio = "Ingresar solo números";
      }
    }

    if (
      data.montoMoneda !== undefined ||
      checkInputs.notNull(data.montoMoneda)
    ) {
      if (!checkInputs.isDecimal(data.montoMoneda)) {
        errors.montoMoneda = "Ingresar solo números";
      }
    }

    if (
      data.puertoEmbarque !== undefined ||
      checkInputs.notNull(data.puertoEmbarque)
    ) {
      if (!checkInputs.isAlphanumeric(data.puertoEmbarque)) {
        errors.puertoEmbarque = "Ingresar solo caracteres alfanuméricos.";
      }
    }
    return errors;
  },
};

//Valida los campos que se encuentran en la seccion Datos Factura del front
export const validationInvoiceDataGeneral = {
  onChange: function checkOnChange(nameInput, value) {
    const response = { value: value, error: null, keyWordError: null };

    switch (nameInput) {
      case "fechaSalida":
      case "informacionInteresEmisor":
      case "tipoSucursal":
      case "tipoTransaccionVenta":
      case "entregaCafe":
        if (!checkInputs.notNull(value)) {
          response.keyWordError = "isNull";
          response.error =
            "Seleccionar la forma de entrega del CAFE, es necesaria.";
        }
        return response;
      case "formatoCafe":
        if (!checkInputs.notNull(value)) {
          response.keyWordError = "isNull";
          response.error =
            "Seleccionar el formato de generación del CAFE, es necesario.";
        }
        return response;
      case "envioContenedorReceptor":
        if (!checkInputs.notNull(value)) {
          response.keyWordError = "isNull";
          response.error = "Seleccionar el envío del contenedor, es necesario.";
        }
        return response;
      case "naturalezaOperacion":
        if (!checkInputs.notNull(value)) {
          response.keyWordError = "isNull";
          response.error =
            "Seleccionar la naturaleza de la operación, es necesaria.";
        }
        return response;
      case "tipoOperacion":
        if (!checkInputs.notNull(value)) {
          response.keyWordError = "isNull";
          response.error = "Seleccionar el tipo de la operación, es necesario.";
        }
        return response;
      case "tiempoPago":
        if (!checkInputs.notNull(value)) {
          response.keyWordError = "isNull";
          response.error = "Seleccionar el tiempo de pago, es necesario.";
        }
        return response;
      default:
        return response;
    }
  },
  onSubmit: function checkOnSubmit(data) {
    const errors = {};

    if (!checkInputs.notNull(data.entregaCafe)) {
      errors.entregaCafe =
        "Seleccionar la forma de entrega del CAFE, es necesaria.";
    }

    if (!checkInputs.notNull(data.formatoCafe)) {
      errors.formatoCafe =
        "Seleccionar el formato de generación del CAFE, es necesario.";
    }

    if (!checkInputs.notNull(data.envioContenedorReceptor)) {
      errors.envioContenedorReceptor =
        "Seleccionar el envío del contenedor, es necesario.";
    }

    if (!checkInputs.notNull(data.naturalezaOperacion)) {
      errors.naturalezaOperacion =
        "Seleccionar la naturaleza de la operación, es necesaria.";
    }

    if (!checkInputs.notNull(data.tipoOperacion)) {
      errors.tipoOperacion =
        "Seleccionar el tipo de la operación, es necesario.";
    }

    if (!checkInputs.notNull(data.tiempoPago)) {
      errors.tiempoPago = "Seleccionar el tiempo de pago, es necesario.";
    }

    return errors;
  },
};

//Valida los campos de farmaceutica del detalle
export const validationPharmaceutical = {
  onSubmit: function checkOnSubmit(data) {
    const errors = {};

    if (!checkInputs.notNull(data.numeroLote)) {
      errors.numeroLote =
        "Ingresar el número de lote es necesario, es necesario.";
    } else if (!checkInputs.isAlphanumeric(data.numeroLote)) {
      errors.numeroLote = "Ingresar solo caracteres alfanuméricos.";
    } else if (data.numeroLote.length > 35 || data.numeroLote.length < 5) {
      errors.numeroLote =
        "El tamaño del número de lote debe estar entre 5 y 35 caracteres.";
    }

    if (!checkInputs.notNull(data.cantidadProductos)) {
      errors.cantidadProductos =
        "Ingresar la cantidad de productos, es necesario.";
    } else if (!checkInputs.isNumeric(data.cantidadProductos)) {
      errors.cantidadProductos = "Ingresar solo números.";
    }

    return errors;
  },
};

//Valida los campos de informacion del pedido comercial relacionado con un item de la factura
export const validationCommercialOrderProduct = {
  onSubmit: function checkOnSubmit(data) {
    const errors = {};

    if (!checkInputs.notNull(data.nroPedidoCompra) || data.nroPedidoCompra === "0") {
      errors.nroPedidoCompra =
        "Ingresar un número de pedido válido, no puede ser vacío ni 0.";
    } else if (!checkInputs.isNumeric(data.nroPedidoCompra)) {
      errors.nroPedidoCompra = "Ingresar solo números.";
    } else if (
      data.nroPedidoCompra.length > 9 ||
      data.nroPedidoCompra.length < 1
    ) {
      errors.nroPedidoCompra =
        "El tamaño del número de pedido debe estar entre 1 y 9 caracteres.";
    }

    if (!checkInputs.notNull(data.nroSecuencial) || data.nroSecuencial === "0") {
      errors.nroSecuencial = "Ingresar el número de secuencial, no puede ser vacío ni 0.";
    } else if (!checkInputs.isNumeric(data.nroSecuencial)) {
      errors.nroSecuencial = "Ingresar solo números.";
    } else if (data.nroSecuencial.length > 3 || data.nroSecuencial.length < 1) {
      errors.nroSecuencial =
        "El tamaño del número de secuencial debe estar entre 1 y 3 caracteres.";
    }

    if (!checkInputs.notNull(data.informacionInteres)) {
      errors.informacionInteres =
        "Ingresar la información de interés del emisor, es necesario.";
    } else if (!checkInputs.isAlphanumeric(data.informacionInteres)) {
      errors.informacionInteres = "Ingresar solo caracteres alfanuméricos.";
    } else if (
      data.informacionInteres.length > 5000 ||
      data.informacionInteres.length < 0
    ) {
      errors.informacionInteres =
        "El tamaño de la información de interés de estar entre 0 y 5000 caracteres.";
    }

    return errors;
  },
};

//Valida los campos de de un vehículo nuevo del detalle
export const validationNewVehicle = {
  onSubmit: function checkOnSubmit(data) {
    const errors = {};

    if (!checkInputs.notNull(data.modalidadOperacionVenta)) {
      errors.modalidadOperacionVenta =
        "Seleccionar la modalidad de operación de la venta, es necesaria.";
    }

    if (!checkInputs.notNull(data.chasis)) {
      errors.chasis = "Ingresar el chasis del vehículo, es necesario.";
    } else if (!checkInputs.isAlphanumeric(data.chasis)) {
      errors.chasis = "Ingresar solo caracteres alfanuméricos.";
    } else if (checkInputs.countLenth(data.chasis) != 17) {
      errors.chasis = "Ingresar 17 caracteres.";
    }

    if (!checkInputs.notNull(data.color)) {
      errors.color = "Ingresar el color del vehículo, es necesario.";
    } else if (!checkInputs.isAlphanumeric(data.color)) {
      errors.color = "Ingresar solo caracteres alfanuméricos.";
    } else if (checkInputs.countLenth(data.color) > 4 || checkInputs.countLenth(data.color) < 1) {
      errors.color = "Ingresar entre 1 y 4 caracteres.";
    }

    if (!checkInputs.notNull(data.tipoCombustible)) {
      errors.tipoCombustible =
        "Seleccionar el tipo de combustible, es necesario.";
    }

    if (!checkInputs.notNull(data.numeroMotor)) {
      errors.numeroMotor = "Ingresar el número del motor, es necesario.";
    } else if (!checkInputs.isAlphanumeric(data.numeroMotor)) {
      errors.numeroMotor = "Ingresar solo caracteres alfanuméricos.";
    } else if (checkInputs.countLenth(data.numeroMotor) > 21 || checkInputs.countLenth(data.numeroMotor) < 1) {
      errors.numeroMotor = "Ingresar entre 1 y 21 caracteres.";
    }

    if (!checkInputs.notNull(data.tipoVehiculo)) {
      errors.tipoVehiculo = "Seleccionar el tipo de vehículo, es necesario.";
    }

    if (!checkInputs.notNull(data.usoVehiculo)) {
      errors.usoVehiculo = "Seleccionar el uso del vehículo, es necesario.";
    }

    if (checkInputs.notNull(data.operacionNoListada)) {
      if (!checkInputs.isAlphanumeric(data.operacionNoListada)) {
        errors.operacionNoListada = "Ingresar solo caracteres alfanuméricos.";
      } else if (checkInputs.countLenth(data.operacionNoListada) > 50 || checkInputs.countLenth(data.operacionNoListada) < 10) {
        errors.operacionNoListada = "Ingresar entre 10 y 50 caracteres."
      }
    }

    if (checkInputs.notNull(data.descripcionColor)) {
      if (!checkInputs.isAlphanumeric(data.descripcionColor)) {
        errors.descripcionColor = "Ingresar solo caracteres alfanuméricos.";
      } else if (checkInputs.countLenth(data.descripcionColor) > 40 || checkInputs.countLenth(data.descripcionColor) < 1) {
        errors.descripcionColor = "Ingresar entre 1 y 40 caracteres."
      }
    }
    if (checkInputs.notNull(data.potenciaMotor)) {
      if (!checkInputs.isNumeric(data.potenciaMotor)) {
        errors.potenciaMotor = "Ingresar solo números";
      } else if (checkInputs.countLenth(data.potenciaMotor) > 4 || checkInputs.countLenth(data.potenciaMotor) < 1) {
        errors.potenciaMotor = "Ingresar entre 1 y 4 dígitos."
      }
    }
    if (checkInputs.notNull(data.capacidadMotor)) {
      if (!checkInputs.isNumeric(data.capacidadMotor)) {
        errors.capacidadMotor = "Ingresar solo números.";
      } else if (checkInputs.countLenth(data.capacidadMotor) > 4 || checkInputs.countLenth(data.capacidadMotor) < 1) {
        errors.capacidadMotor = "Ingresar entre 1 y 4 dígitos."
      }
    }
    if (checkInputs.notNull(data.pesoNeto)) {
      if (!checkInputs.isDecimal(data.pesoNeto)) {
        errors.pesoNeto = "Ingresar solo números.";
      } else if (checkInputs.countLenth(data.pesoNeto) > 15) {
        errors.pesoNeto = "Ingresar máximo 15 dígitos."
      }
    }
    if (checkInputs.notNull(data.pesoBruto)) {
      if (!checkInputs.isDecimal(data.pesoBruto)) {
        errors.pesoBruto = "Ingresar solo números.";
      } else if (checkInputs.countLenth(data.pesoBruto) > 15) {
        errors.pesoBruto = "Ingresar máximo 15 dígitos."
      }
    }
    if (checkInputs.notNull(data.tipoCombustibleNoListado)) {
      if (!checkInputs.isAlphanumeric(data.tipoCombustibleNoListado)) {
        errors.tipoCombustibleNoListado =
          "Ingresar solo caracteres alfanuméricos.";
      } else if (checkInputs.countLenth(data.tipoCombustibleNoListado) > 40 || checkInputs.countLenth(data.tipoCombustibleNoListado) < 10) {
        errors.tipoCombustibleNoListado = "Ingresar entre 10 y 40 caracteres."
      }
    }
    if (checkInputs.notNull(data.capacidadTraccion)) {
      if (!checkInputs.isDecimal(data.capacidadTraccion)) {
        errors.capacidadTraccion = "Ingresar solo números.";
      } else if (checkInputs.countLenth(data.capacidadTraccion) > 15) {
        errors.capacidadTraccion = "Ingresar máximo 15 dígitos."
      }
    }
    if (checkInputs.notNull(data.distanciaEjes)) {
      if (!checkInputs.isDecimal(data.distanciaEjes)) {
        errors.distanciaEjes = "Ingresar solo números.";
      } else if (checkInputs.countLenth(data.distanciaEjes) > 15) {
        errors.distanciaEjes = "Ingresar máximo 15 dígitos."
      }
    }
    if (checkInputs.notNull(data.anioModeloFabricacion)) {
      if (!checkInputs.isNumeric(data.anioModeloFabricacion)) {
        errors.anioModeloFabricacion = "Ingresar solo números.";
      } else if (checkInputs.countLenth(data.anioModeloFabricacion) != 4) {
        errors.anioModeloFabricacion = "Ingresar 4 dígitos."
      }
    }
    if (checkInputs.notNull(data.anioFabricacion)) {
      if (!checkInputs.isNumeric(data.anioFabricacion)) {
        errors.anioFabricacion = "Ingresar solo números.";
      } else if (checkInputs.countLenth(data.anioFabricacion) != 4) {
        errors.anioFabricacion = "Ingresar 4 dígitos."
      }
    }
    if (checkInputs.notNull(data.tipoPinturaNoListado)) {
      if (!checkInputs.isAlphanumeric(data.tipoPinturaNoListado)) {
        errors.tipoPinturaNoListado = "Ingresar solo caracteres alfanuméricos.";
      } else if (checkInputs.countLenth(data.tipoPinturaNoListado) > 50 || checkInputs.countLenth(data.tipoPinturaNoListado) < 10) {
        errors.tipoPinturaNoListado = "Ingresar entre 10 y 50 caracteres."
      }
    }
    if (checkInputs.notNull(data.capacidadMaxima)) {
      if (!checkInputs.isNumeric(data.capacidadMaxima)) {
        errors.capacidadMaxima = "Ingresar solo números.";
      } else if (checkInputs.countLenth(data.capacidadMaxima) > 3 || checkInputs.countLenth(data.capacidadMaxima) < 1) {
        errors.capacidadMaxima = "Ingresar entre 1 y 3 dígitos."
      }
    }

    return errors;
  },
};
